// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__hxiGR","employee-header-item":"Header_employee-header-item__+lCyH"};